<div class="input" [formGroup]="form">
  <label [for]="id">{{ label }}</label>
  <input [ngClass]="invalid ? 'invalid' : ''" [id]="id" [placeholder]="placeHolder" formControlName="{{ controlName }}" />
  <ng-content></ng-content>
</div>
